import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Detail_07_Interface';
import { DataEntity_Main_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Main_07_Interface';
import { DataEntity_Resolution_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Resolution_07_Interface';
import { DataEntity_Working_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Working_07_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity07Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno07/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_07_Interface,
    detail: Array<DataEntity_Detail_07_Interface>,
    resolution: Array<DataEntity_Resolution_07_Interface>,
    working: Array<DataEntity_Working_07_Interface>,

    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,

    FolderName: string,

    Capability: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,


    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,

        reference: item.reference,
        indication: item.indication,
        error: item.error,
        uncertainty: item.uncertainty,
        converage: item.converage,
        repeatability: item.repeatability,
        eccentricity: item.eccentricity,
      })
    }

    var model={
      id:model_temp.id,
      filename: Filename,

      pdf_src: FolderName,

      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,

      capability: Capability,

      before_from: model_temp.before_from,
      before_to: model_temp.before_to,
      before_method: model_temp.before_method,
      mapping: model_temp.mapping,



      unit_working: model_temp.unit_working,
      unit_reference: model_temp.unit_reference,
      unit_indication: model_temp.unit_indication,
      unit_error: model_temp.unit_error,
      unit_correction: model_temp.unit_correction,
      unit_uncertainty: model_temp.unit_uncertainty,
      unit_eccentricity: model_temp.unit_eccentricity,
      unit_repeatability: model_temp.unit_repeatability,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

    }

    var body = {
      Calibration_id: Calibration_Id,
      dataentity_id: DataEntity_id,
      model: model,
      resolution : resolution,
      working : working,

      detail: detail_list,
      mesured: mesured_list,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,

    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno07/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno07/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno07/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }


}
